import { createWebHistory, createRouter } from "vue-router";
import { isAdminSessionValid } from "./utils/adminSession";
import { isStudentExamSignedIn } from "./utils/studentSession";

const STUDENT_GAME_PATHS = new Set(["/game", "/gametopics", "/gamequestions"]);

const routes = [
    {
        path: "/",
        name: "FirstPage",
        component: () => import("./components/FirstPage.vue"),
    },
    {
        path: "/admin/",
        alias: "/admin",
        name: "Admin",
        component: () => import("./components/admin/Admin.vue"),
        meta: { adminLogin: true },
    },

    {
        path: "/admin/menu",
        name: "AdminMenu",
        component: () => import("./components/admin/AdminMenu.vue"),
        meta: { requiresAdmin: true },
    },
    {
        path: "/admin/passwords",
        name: "Passwords",
        component: () => import("./components/admin/Passwords.vue"),
        meta: { requiresAdmin: true },
    },

    {
        path: "/admin/stats",
        name: "Statistic",
        component: () => import("./components/admin/AllStatistic.vue"),
        meta: { requiresAdmin: true },
    },
    {
        path: "/admin/exam-mascots",
        name: "AdminExamMascots",
        component: () => import("./components/admin/ExamMascotsSettings.vue"),
        meta: { requiresAdmin: true },
    },

    {
        path: "/chapters",
        name: "ChapterList",
        component: () => import("./components/admin/ChapterList.vue"),
        meta: { requiresAdmin: true },
    },
    {
        path: "/add",
        name: "AddChapter",
        component: () => import("./components/admin/AddChapter.vue"),
        meta: { requiresAdmin: true },
    },
    {
        path: "/topics",
        name: "TopicList",
        component: () => import("./components/admin/TopicList.vue"),
        meta: { requiresAdmin: true },
    },
    {
        path: "/add-topic",
        name: "AddTopic",
        component: () => import("./components/admin/AddTopic.vue"),
        meta: { requiresAdmin: true },
    },
    {
        path: '/questions',
        name: 'TopicQuestions',
        component: () => import("./components/admin/QuestionsList.vue"),
        meta: { requiresAdmin: true },
    },
    {
        path: '/question',
        name: 'QuestionForm',
        component: () => import("./components/admin/AddQuestion.vue"),
        meta: { requiresAdmin: true },
    },
    {
        path: "/game",
        name: "Game",
        component: () => import("./components/Game"),
        props: true,
    },
    {
        path: "/gametopics",
        name: "GameTopics",
        component:() => import("./components/TopicsGame.vue")
    },
    {
        path: "/gamequestions",
        name: "GameQuestions",
        component:() => import("./components/QuestionsGame.vue")
    }

];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const CHUNK_RELOAD_KEY = "chunk_reload_ts";

function isChunkLoadError(err) {
    if (!err) return false;
    const name = err.name || "";
    const msg = String(err.message || err);
    return (
        name === "ChunkLoadError" ||
        /Loading chunk [\w-]+ failed/i.test(msg) ||
        /ChunkLoadError/i.test(msg) ||
        /Failed to fetch dynamically imported module/i.test(msg)
    );
}

router.onError((err) => {
    if (!isChunkLoadError(err)) {
        return;
    }
    const now = Date.now();
    const prev = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || "0");
    if (now - prev < 10_000) {
        console.error(
            "[router] Повторная ошибка загрузки кода страницы. Обновите вкладку вручную или сбросьте кэш.",
            err
        );
        return;
    }
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
    window.location.reload();
});

router.beforeEach((to, _from, next) => {
    const needsAdmin = to.matched.some((record) => record.meta && record.meta.requiresAdmin);

    if (to.meta.adminLogin) {
        if (isAdminSessionValid()) {
            next({ name: "AdminMenu" });
            return;
        }
        next();
        return;
    }
    if (needsAdmin && !isAdminSessionValid()) {
        next({
            name: "Admin",
            query: { redirect: to.fullPath },
        });
        return;
    }
    if (STUDENT_GAME_PATHS.has(to.path) && !isStudentExamSignedIn()) {
        next({ path: "/", query: { needLogin: "1" } });
        return;
    }
    next();
});

export default router;